import React from 'react'
import { Form, FormGroup, Input, InputGroup, InputGroupAddon, InputGroupText, Label, Row, Col } from 'reactstrap'
import { ReactSVGPanZoom, TOOL_PAN, INITIAL_VALUE } from 'react-svg-pan-zoom'
import { AutoSizer } from 'react-virtualized'
import './soilCalculator.scss'

class SoilCalculator extends React.Component {
  constructor(props) {
    super(props)
    this.onValueChange = this.onValueChange.bind(this);
    this.setUnit = this.setUnit.bind(this);
    this.changeTool = this.changeTool.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.state = {
      min: 1,
      max: 100,
      maxWidth: 100,
      maxLength: 100,
      maxDepth: 30,
      width: 91.44,
      length: 30.5,
      depth: 12.5,
      widthDisplay: 3,
      lengthDisplay: 1,
      depthDisplay: 5,
      widthUnit: 'ft',
      lengthUnit: 'ft',
      depthUnit: 'in',
      tool: TOOL_PAN,
      value: INITIAL_VALUE
    }
    this.factor = {m: 100, cm: 1, ft: 30.48, in: 2.54, yd: 91.44}
    this.cubicFactor = { cft: 3.53147e-5, cyd: 1.30795e-6, cm: 1e-6, cq: 0.00105669 }
  }

  changeTool(nextTool) {
    this.setState({tool: nextTool})
  }

  changeValue(nextValue) {
    this.setState({value: nextValue})
  }

  onValueChange(dimension, e) {
    this.setState({
      [`${dimension}Display`]: e
    })

    const unit = this.state[`${dimension}Unit`]
    this.setState({
     [dimension]: e * this.factor[unit]
    })
  }

  setUnit(dimension, unit) {
    this.setState({
      [`${dimension}Display`]: this.state[dimension] / this.factor[unit]
    })
    this.setState({
      [`${dimension}Unit`]: unit
    })
  }

  getCubicMeasurements(unit) {
    return this.state.width * this.state.length * this.state.depth * this.cubicFactor[unit]
  }

  render() {
    return (
      <div className="soilCalculator">
        <Row className="soilTopRow py-4 px-4" >
          <Col sm={6}>
            <Form className="soilForm">
            <FormGroup row>
              <Label for="width" sm={2} className="pr-5"><strong>Width</strong></Label>
              <Col sm={8}>
                <InputGroup>
                  <Input
                    name="width"
                    placeholder="Width"
                    min={this.state.min}
                    // max={this.state.maxWidth}
                    type="number"
                    step="1"
                    value={this.state.widthDisplay}
                    onChange={(e) => this.onValueChange('width', `${e.target.value}`)}/>
                  <InputGroupAddon addonType="append">
                    <InputGroupText className={this.state.widthUnit === 'in' ? 'active' : ''} onClick={(e) => this.setUnit('width', 'in')}>in</InputGroupText>
                    <InputGroupText className={this.state.widthUnit === 'ft' ? 'active' : ''} onClick={(e) => this.setUnit('width', 'ft')}>ft</InputGroupText>
                    <InputGroupText className={this.state.widthUnit === 'yd' ? 'active' : ''} onClick={(e) => this.setUnit('width', 'yd')}>yd</InputGroupText>
                    <InputGroupText className={this.state.widthUnit === 'cm' ? 'active' : ''} onClick={(e) => this.setUnit('width', 'cm')}>cm</InputGroupText>
                    <InputGroupText className={this.state.widthUnit === 'm' ? 'active' : ''} onClick={(e) => this.setUnit('width', 'm')}>m</InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="length" sm={2} className="pr-5"><strong>Length</strong></Label>
              <Col sm={8}>
                <InputGroup>
                  <Input
                    name="length"
                    placeholder="Length"
                    min={this.state.min}
                    // max={this.state.maxLength}
                    type="number"
                    step="1"
                    value={this.state.lengthDisplay}
                    onChange={(e) => this.onValueChange('length', `${e.target.value}`)}/>
                  <InputGroupAddon addonType="append">
                    <InputGroupText className={this.state.lengthUnit === 'in' ? 'active' : ''} onClick={(e) => this.setUnit('length', 'in')}>in</InputGroupText>
                    <InputGroupText className={this.state.lengthUnit === 'ft' ? 'active' : ''} onClick={(e) => this.setUnit('length', 'ft')}>ft</InputGroupText>
                    <InputGroupText className={this.state.lengthUnit === 'yd' ? 'active' : ''} onClick={(e) => this.setUnit('length', 'yd')}>yd</InputGroupText>
                    <InputGroupText className={this.state.lengthUnit === 'cm' ? 'active' : ''} onClick={(e) => this.setUnit('length', 'cm')}>cm</InputGroupText>
                    <InputGroupText className={this.state.lengthUnit === 'm' ? 'active' : ''} onClick={(e) => this.setUnit('length', 'm')}>m</InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label for="depth" sm={2} className="pr-5"><strong>Depth</strong></Label>
              <Col sm={8}>
                <InputGroup>
                  <Input
                    name="depth"
                    placeholder="Depth"
                    min={this.state.min}
                    // max={this.state.maxDepth}
                    type="number"
                    step="1"
                    value={this.state.depthDisplay}
                    onChange={(e) => this.onValueChange('depth', `${e.target.value}`)}/>
                  <InputGroupAddon addonType="append">
                    <InputGroupText className={this.state.depthUnit === 'in' ? 'active' : ''} onClick={(e) => this.setUnit('depth', 'in')}>in</InputGroupText>
                    <InputGroupText className={this.state.depthUnit === 'ft' ? 'active' : ''} onClick={(e) => this.setUnit('depth', 'ft')}>ft</InputGroupText>
                    <InputGroupText className={this.state.depthUnit === 'yd' ? 'active' : ''} onClick={(e) => this.setUnit('depth', 'yd')}>yd</InputGroupText>
                    <InputGroupText className={this.state.depthUnit === 'cm' ? 'active' : ''} onClick={(e) => this.setUnit('depth', 'cm')}>cm</InputGroupText>
                    <InputGroupText className={this.state.depthUnit === 'm' ? 'active' : ''} onClick={(e) => this.setUnit('depth', 'm')}>m</InputGroupText>
                  </InputGroupAddon>
                </InputGroup>
              </Col>
            </FormGroup>
          </Form>
          </Col>
          <Col sm={6} className="pl-5">
            <div><h3>How much soil do you need?</h3></div>
            <div><strong>{ this.getCubicMeasurements('cq') ? Math.round(this.getCubicMeasurements('cq') * 100) / 100 : 0 }</strong> quart</div>
            <div><strong>{ this.getCubicMeasurements('cft') ? Math.round(this.getCubicMeasurements('cft') * 100) / 100 : 0 }</strong> cubic feet</div>
            <div><strong>{ this.getCubicMeasurements('cyd') ? Math.round(this.getCubicMeasurements('cyd') * 100) / 100 : 0}</strong> cubic yard</div>
            <div><strong>{ this.getCubicMeasurements('cm') ? Math.round(this.getCubicMeasurements('cm') * 100) / 100 : 0}</strong> cubic meter</div>
          </Col>
        </Row>
        <Row>
        <div style={{width: "1100px", height: "500px"}}>
          <AutoSizer>
            {(({width, height}) => width === 0 || height === 0 ? null : (
              <ReactSVGPanZoom width={width} height={height} background="#fff" ref={Viewer => this.Viewer = Viewer}
              tool={this.state.tool} onChangeTool={tool => this.changeTool(tool)}
              value={this.state.value} onChangeValue={value => this.changeValue(value)}
              detectWheel={false}
              detectAutoPan={false}
              miniatureProps={{ position: 'none' }}>
                <svg width={1440} height={1440}>
                  <rect x="50" y="200" width={this.state.width * 5} height={this.state.depth * 5} fill="#BE8F60" stroke="#543D2E" strokeWidth="1"/>
                  <rect x="397" y={200-(this.state.length * 2)} width={this.state.width * 5} height={this.state.length * 2} fill="#BE8F60" stroke="#543D2E" strokeWidth="2" transform="skewX(-60)" fillOpacity="0.6" />
                  <rect x={this.state.width * 5 + 50} y={228+(this.state.width * 2.90)} width={this.state.length * 3.45} height={this.state.depth*5} fill="#BE8F60" stroke="#543D2E" strokeWidth="2" transform="skewY(-30)" fillOpacity="0.8"></rect>
                </svg>
              </ReactSVGPanZoom>
            ))}
          </AutoSizer>
        </div>
        </Row>
      </div>
    )
  }
}

export default SoilCalculator
